import { mapSagasFromConfigurations } from '../../helpers/sagas';
import { configurations } from './configurations';

function* cpdCategorySagas() {
  yield mapSagasFromConfigurations('cpdCategorys')(configurations)
}

export default cpdCategorySagas;


// WEBPACK FOOTER //
// ./src/state/modules/areas-of-advice/sagas.js